import { render, staticRenderFns } from "./respMessage.vue?vue&type=template&id=9c6b9618"
import script from "./respMessage.vue?vue&type=script&lang=js"
export * from "./respMessage.vue?vue&type=script&lang=js"
import style0 from "./respMessage.vue?vue&type=style&index=0&id=9c6b9618&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports